import { call, all, getContext, put, takeEvery } from 'redux-saga/effects';
import { patterns as pinPatterns } from 'next/entities/pins';
import { patterns as experiencePatterns } from 'next/entities/experiences';
import { reject, replace, readOne } from './actions';

function* fetchUser({ payload: id }) {
  try {
    const api = yield getContext('api');
    const { user } = yield call(api.getAccountUser, id);
    yield put(replace({ ...user, id }));
  } catch (error) {
    yield put(reject(error));
  }
}

function* fetchExperienceUsers({ payload: { createdBy, updatedBy } }) {
  yield all([
    call(fetchUser, readOne(createdBy)),
    call(fetchUser, readOne(updatedBy)),
  ]);
}

export default function* saga() {
  // External actions
  yield takeEvery(
    [pinPatterns.replace, experiencePatterns.replace],
    fetchExperienceUsers
  );
}
